import axios from 'axios'

const state = {
    setMktPayoutInfo: null,
    setGlobalBalance: null,
}

const getters = {
    setMktPayoutInfo (state) {
        return state.setMktPayoutInfo
    },
    setGlobalBalance (state) {
        return state.setGlobalBalance
    },
    // console.log(Object.assign({}, activeUser))
}

const actions = {
    async fetchMktPayoutDetails({ commit }, marketerObj) {
        let response = await axios.post(`/payouts/fetchMktPayoutInfo`, marketerObj)
        if(!response.data.error){
            return commit('SET_MKT_PAYOUT_INFO', response.data.result)
        }
        return response.data
    },
    
    async fetchCurrentGlobalBal({ commit }) {
        commit('SET_GLOBAL_BALANCE', null)
        let response = await axios.post(`/payouts/fetchGlobalBalance`)
        if(!response.data.error){
            return commit('SET_GLOBAL_BALANCE', response.data.result)
        }
        return response.data
    },
}

const mutations = {
    SET_MKT_PAYOUT_INFO: (state, setMktPayoutInfo) => (state.setMktPayoutInfo = setMktPayoutInfo),
    SET_GLOBAL_BALANCE: (state, setGlobalBalance) => (state.setGlobalBalance = setGlobalBalance),
}

export default {
    state,
    getters,
    actions,
    mutations
}